import { dynamicRequire } from '@sentry/utils';
var lazyLoadedNodePerformanceMonitoringIntegrations = [function () {
  var integration = dynamicRequire(module, './apollo');
  return new integration.Apollo();
}, function () {
  var integration = dynamicRequire(module, './apollo');
  return new integration.Apollo({
    useNestjs: true
  });
}, function () {
  var integration = dynamicRequire(module, './graphql');
  return new integration.GraphQL();
}, function () {
  var integration = dynamicRequire(module, './mongo');
  return new integration.Mongo();
}, function () {
  var integration = dynamicRequire(module, './mongo');
  return new integration.Mongo({
    mongoose: true
  });
}, function () {
  var integration = dynamicRequire(module, './mysql');
  return new integration.Mysql();
}, function () {
  var integration = dynamicRequire(module, './postgres');
  return new integration.Postgres();
}];
export { lazyLoadedNodePerformanceMonitoringIntegrations };